import {computed} from "@preact/signals-core";
import CharCreate from "../_helper/charcreate";
import {s_char} from "./s_char";
import {ReadonlySignal} from "@preact/signals-react";
import {
    s_char_mods_cha,
    s_char_mods_ges,
    s_char_mods_str,
    s_char_mods_wah,
    s_char_mods_wil,
    s_char_mods_zae
} from "./s_char_mods";


// <attr>_c from character create point + <attr>_r raised points + character race base
const s_char_attr_sum = (attr: string) => computed(() => {
    if (!CharCreate.races.hasOwnProperty(s_char.value.race)) return 0;
    return s_char.value[attr+'_c'] + s_char.value[attr + '_r'] + parseInt(CharCreate.races[s_char.value.race][attr]);
});

const s_char_attr_step = (attr: string) => computed(() => {
    return s_char.value[attr];
});
const s_char_attr_step_cc = (attr: string) => computed(() => {
    return CharCreate.assign[s_char_attr_sum(attr).value].s;
})

const s_char_attr_else = (attr) => {
    let ret = '-';
    let value = s_char_attr_sum(attr).value
    const assign = CharCreate.assign[value];
    if (assign && assign.hasOwnProperty('v')) {
        if (attr === 'ges') {
            ret = 'K Vert.: ' + assign.v;
        } else if (attr === 'cha') {
            ret = 'S Vert.: ' + assign.v;
        } else if (attr === 'wah') {
            ret = 'M Vert.: ' + assign.v;
        } else if (attr === 'zae') {
            ret = 'Körperl.: EP ' + assign.ep + '/ WS ' + assign.ws + ' <br> BS ' + assign.bs + ' / TS ' + assign.ts;
        }
        if (attr === 'wil') {
            ret = 'MR: ' + assign.mr;
        }
    }
    return ret;
}

const s_char_attr_str: ReadonlySignal<number> = computed(() => s_char_attr_sum('str').value);
const s_char_attr_zae: ReadonlySignal<number> = computed(() => s_char_attr_sum('zae').value);
const s_char_attr_ges: ReadonlySignal<number> = computed(() => s_char_attr_sum('ges').value);
const s_char_attr_wah: ReadonlySignal<number> = computed(() => s_char_attr_sum('wah').value);
const s_char_attr_wil: ReadonlySignal<number> = computed(() => s_char_attr_sum('wil').value);
const s_char_attr_cha: ReadonlySignal<number> = computed(() => s_char_attr_sum('cha').value);

const s_char_attr_str_step = computed(() => Math.ceil(s_char_attr_sum('str').value / 3 + 1) + s_char_mods_str.value);
const s_char_attr_zae_step = computed(() => Math.ceil(s_char_attr_sum('zae').value / 3 + 1) + s_char_mods_zae.value);
const s_char_attr_ges_step = computed(() => Math.ceil(s_char_attr_sum('ges').value / 3 + 1) + s_char_mods_ges.value);
const s_char_attr_wah_step = computed(() => Math.ceil(s_char_attr_sum('wah').value / 3 + 1) + s_char_mods_wah.value);
const s_char_attr_wil_step = computed(() => Math.ceil(s_char_attr_sum('wil').value / 3 + 1) + s_char_mods_wil.value);
const s_char_attr_cha_step = computed(() => Math.ceil(s_char_attr_sum('cha').value / 3 + 1) + s_char_mods_cha.value);

export {
    s_char_attr_str_step,
    s_char_attr_str,
    s_char_attr_zae_step,
    s_char_attr_zae,
    s_char_attr_ges_step,
    s_char_attr_ges,
    s_char_attr_wah_step,
    s_char_attr_wah,
    s_char_attr_wil_step,
    s_char_attr_wil,
    s_char_attr_cha_step,
    s_char_attr_cha,
    s_char_attr_sum,
    s_char_attr_else,
    s_char_attr_step,
    s_char_attr_step_cc
}